import React, { useState, useEffect } from 'react';
import api from '../../../../../config/axios';
import Swal from 'sweetalert2';
import { FaRegSave, FaTimes, FaPlus, FaTrash } from 'react-icons/fa';

const SubLancamentoModal = ({ sublancamento, onClose, onSublancamentoAtualizado }) => {
    const [categoriaPrincipalId, setCategoriaPrincipalId] = useState('');
    const [sublancamentos, setSublancamentos] = useState([{
        categoria_sub_id: '',
        forma_pagamento: '',
        taxa: '0%',
        conta_bancaria_id: ''
    }]);
    const [categorias, setCategorias] = useState([]);
    const [categoriasPrincipaisComSub, setCategoriasPrincipaisComSub] = useState([]);
    const [contasBancarias, setContasBancarias] = useState([]);
    const [tituloModal, setTituloModal] = useState('');
    const [isEdicao, setIsEdicao] = useState(false);

    useEffect(() => {
        if (sublancamento && sublancamento.sublancamentos) {
            setCategoriaPrincipalId(sublancamento.categoria_principal_id || '');
            setSublancamentos(sublancamento.sublancamentos.map(sub => ({
                id: sub.id,
                categoria_sub_id: sub.categoria_sub_id || '',
                forma_pagamento: sub.forma_pagamento || '',
                taxa: `${parseFloat(sub.taxa || 0).toFixed(2)}%`,
                conta_bancaria_id: sub.conta_bancaria_id || ''
            })));
            setTituloModal('Editar Sublançamentos');
            setIsEdicao(true);
        } else {
            setTituloModal('Novo Sublançamento');
            setIsEdicao(false);
        }

        fetchCategorias();
        fetchContasBancarias();
        fetchCategoriasPrincipaisComSub();
    }, [sublancamento]);

    const fetchCategorias = async () => {
        try {
            const response = await api.get('/categorias-financeiras?limit=1000');
            setCategorias(response.data.records || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar categorias', 'error');
        }
    };

    const fetchCategoriasPrincipaisComSub = async () => {
        try {
            const response = await api.get('/sublancamentos?limit=10000');
            const categoriasComSub = response.data.records.map(item => item.categoria_principal_id);
            setCategoriasPrincipaisComSub(categoriasComSub);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar categorias com sublançamentos', 'error');
        }
    };

    const fetchContasBancarias = async () => {
        try {
            const response = await api.get('/contas-bancarias/para-lancamentos');
            setContasBancarias(response.data || []);
        } catch (error) {
            Swal.fire('Erro', 'Erro ao carregar contas bancárias', 'error');
        }
    };

    const handleAddSublancamento = () => {
        setSublancamentos([...sublancamentos, {
            categoria_sub_id: '',
            forma_pagamento: '',
            taxa: '0%',
            conta_bancaria_id: ''
        }]);
    };

    const handleRemoveSublancamento = (index) => {
        if (sublancamentos.length === 1) {
            Swal.fire('Atenção', 'Deve haver pelo menos um sublançamento', 'warning');
            return;
        }
        const newSublancamentos = sublancamentos.filter((_, i) => i !== index);
        setSublancamentos(newSublancamentos);
    };

    const handleSublancamentoChange = (index, field, value) => {
        const newSublancamentos = [...sublancamentos];

        if (field === 'taxa') {
            let inputValue = value.replace(/[^0-9.]/g, "");
            if (parseFloat(inputValue) > 100) inputValue = "100";
            if (inputValue !== '') inputValue = inputValue + "%";
            newSublancamentos[index][field] = inputValue;
        } else {
            newSublancamentos[index][field] = value;
        }

        setSublancamentos(newSublancamentos);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!categoriaPrincipalId) {
            Swal.fire('Atenção', 'A categoria principal é obrigatória', 'warning');
            return;
        }

        for (let i = 0; i < sublancamentos.length; i++) {
            const sub = sublancamentos[i];
            if (!sub.categoria_sub_id) {
                Swal.fire('Atenção', `A categoria do sublançamento ${i + 1} é obrigatória`, 'warning');
                return;
            }

            if (sub.categoria_sub_id === categoriaPrincipalId) {
                Swal.fire('Atenção', 'A subcategoria não pode ser igual à categoria principal', 'warning');
                return;
            }

            const taxaNumero = parseFloat(sub.taxa.replace('%', ''));
            if (taxaNumero < 0 || taxaNumero > 100) {
                Swal.fire('Atenção', `A taxa do sublançamento ${i + 1} deve estar entre 0 e 100`, 'warning');
                return;
            }
        }

        Swal.fire({
            title: 'Carregando...',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });

        try {
            if (isEdicao) {
                const response = await api.get('/sublancamentos', {
                    params: {
                        categoria_principal_id: categoriaPrincipalId,
                        limit: 1000
                    }
                });

                const sublancamentosExistentes = response.data.records || [];

                for (const sub of sublancamentosExistentes) {
                    await api.delete(`/sublancamentos/${sub.id}`);
                }

                for (const sub of sublancamentos) {
                    const dataToSend = {
                        categoria_principal_id: parseInt(categoriaPrincipalId),
                        categoria_sub_id: parseInt(sub.categoria_sub_id),
                        forma_pagamento: sub.forma_pagamento || null,
                        taxa: parseFloat(sub.taxa.replace('%', '')),
                        conta_bancaria_id: sub.conta_bancaria_id ? parseInt(sub.conta_bancaria_id) : null
                    };
                    await api.post('/sublancamentos', dataToSend);
                }
                Swal.fire('Sucesso', 'Sublançamentos atualizados com sucesso', 'success');
            } else {
                for (const sub of sublancamentos) {
                    const dataToSend = {
                        categoria_principal_id: parseInt(categoriaPrincipalId),
                        categoria_sub_id: parseInt(sub.categoria_sub_id),
                        forma_pagamento: sub.forma_pagamento || null,
                        taxa: parseFloat(sub.taxa.replace('%', '')),
                        conta_bancaria_id: sub.conta_bancaria_id ? parseInt(sub.conta_bancaria_id) : null
                    };
                    await api.post('/sublancamentos', dataToSend);
                }
                Swal.fire('Sucesso', 'Sublançamentos criados com sucesso', 'success');
            }

            onSublancamentoAtualizado();
        } catch (error) {
            Swal.close();
            Swal.fire('Erro', error.response?.data?.message || 'Erro ao salvar sublançamento', 'error');
        }
    };

    return (
        <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="fw-bold mt-2">{tituloModal}</h4>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="row mb-4">
                                <div className="col-12">
                                    <label className="form-label fw-bold">Categoria Principal</label>
                                    <select
                                        className="form-select"
                                        value={categoriaPrincipalId}
                                        onChange={(e) => setCategoriaPrincipalId(e.target.value)}
                                        disabled={isEdicao}
                                        required
                                    >
                                        <option value="">Selecione...</option>
                                        {categorias
                                            .filter(cat => isEdicao || !categoriasPrincipaisComSub.includes(cat.id))
                                            .map(cat => (
                                                <option key={cat.id} value={cat.id}>{cat.nome}</option>
                                            ))}
                                    </select>
                                </div>
                            </div>

                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <h5 className="fw-bold mb-0">Sublançamentos</h5>
                                    <button
                                        type="button"
                                        className="btn btn-outline-primary"
                                        onClick={handleAddSublancamento}
                                    >
                                        <FaPlus /> Adicionar
                                    </button>
                                </div>
                            </div>

                            {sublancamentos.map((sub, index) => (
                                <div key={index} className="border rounded p-3 mb-3 position-relative">
                                    {sublancamentos.length > 1 && (
                                        <button
                                            type="button"
                                            className="btn btn-danger btn-sm position-absolute top-0 end-0 m-2"
                                            onClick={() => handleRemoveSublancamento(index)}
                                            title="Remover"
                                        >
                                            <FaTrash />
                                        </button>
                                    )}

                                    <div className="row">
                                        <div className="col-lg-6 col-12">
                                            <label className="form-label fw-bold">Categoria do Sublançamento</label>
                                            <select
                                                className="form-select"
                                                value={sub.categoria_sub_id}
                                                onChange={(e) => handleSublancamentoChange(index, 'categoria_sub_id', e.target.value)}
                                                required
                                            >
                                                <option value="">Selecione...</option>
                                                {categorias
                                                    .filter(cat => cat.id.toString() !== categoriaPrincipalId.toString())
                                                    .map(cat => (
                                                        <option key={cat.id} value={cat.id}>{cat.nome}</option>
                                                    ))}
                                            </select>
                                        </div>
                                        <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Forma de Pagamento</label>
                                            <select
                                                className="form-select"
                                                value={sub.forma_pagamento}
                                                onChange={(e) => handleSublancamentoChange(index, 'forma_pagamento', e.target.value)}
                                            >
                                                <option value="">Todas</option>
                                                <option value="cartao_credito">Cartão de Crédito</option>
                                                <option value="cartao_debito">Cartão de Débito</option>
                                                <option value="pix">PIX</option>
                                                <option value="dinheiro">Dinheiro</option>
                                                <option value="boleto">Boleto</option>
                                                <option value="ted">TED</option>
                                                <option value="doc">DOC</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-lg-6 col-12">
                                            <label className="form-label fw-bold">Taxa (%)</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={sub.taxa}
                                                onChange={(e) => handleSublancamentoChange(index, 'taxa', e.target.value)}
                                                placeholder="0.00%"
                                            />
                                        </div>
                                        <div className="col-lg-6 col-12 mt-lg-0 mt-3">
                                            <label className="form-label fw-bold">Conta Bancária</label>
                                            <select
                                                className="form-select"
                                                value={sub.conta_bancaria_id}
                                                onChange={(e) => handleSublancamentoChange(index, 'conta_bancaria_id', e.target.value)}
                                            >
                                                <option value="">Selecione...</option>
                                                {contasBancarias.map(conta => (
                                                    <option key={conta.id} value={conta.id}>
                                                        {conta.nome_exibicao || conta.nome}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-danger" onClick={onClose}>
                            <FaTimes className="me-1" />
                            Fechar
                        </button>
                        <button type="button" className="btn btn-custom-primary" onClick={handleSubmit}>
                            <FaRegSave className="me-1" />
                            Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SubLancamentoModal;
